var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCombinedShapeCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "-11 -22 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.06749 0.664233C1.6752 0.359209 1.10797 0.386938 0.747483 0.747422C0.356959 1.13795 0.356959 1.77111 0.747483 2.16164L14.4404 15.8545L0.747483 29.5474L0.664294 29.6416C0.35927 30.0339 0.386999 30.6012 0.747483 30.9616C1.13801 31.3522 1.77117 31.3522 2.1617 30.9616L15.8546 17.2687L29.5475 30.9616L29.6417 31.0448C30.034 31.3498 30.6012 31.3221 30.9617 30.9616C31.3522 30.5711 31.3522 29.9379 30.9617 29.5474L17.2688 15.8545L30.9617 2.16164L31.0449 2.06743C31.3499 1.67514 31.3222 1.10791 30.9617 0.747422C30.5712 0.356898 29.938 0.356898 29.5475 0.747422L15.8546 14.4403L2.1617 0.747422L2.06749 0.664233Z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCombinedShapeCross);
export default __webpack_public_path__ + "static/media/CombinedShapeCross.ea92aa8b0602dd26d0a841a10cbf6aca.svg";
export { ForwardRef as ReactComponent };